import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { DisputeReason } from '../../coaching-base/config';
import {
    CmpsForm,
    CmpsFormBuilder,
} from '../../coaching-observation/experimental.form';
import { TranslationKeyMap } from '../coaching-commitment.i18n';

import { DisputeFormFields, DisputeFormValue } from './dispute.commitment.form';

@Component({
    selector: '[cmpsCommitmentDispute]',
    templateUrl: './dispute.commitment.component.html',
})
export class DisputeCommitmentComponent implements OnInit, OnDestroy {
    /** @private */ _disputeReasonsOpts: Array<{
        value: number;
        label: string;
    }>;

    /** @private */ _i18n = TranslationKeyMap;

    // eslint-disable-next-line accessor-pairs
    private set _disputeReasons(value: DisputeReason[]) {
        this._disputeReasonsOpts = (value || []).map((e) => ({
            value: e.disputeReasonId,
            label: e.disputeReason,
        }));
    }

    /** @private */ _form: CmpsForm<DisputeFormFields, DisputeFormValue>;

    constructor(
        private readonly _formBuilder: CmpsFormBuilder,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            DisputeCommitmentComponent,
            any
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: DisputeReason[],
    ) {
        this._disputeReasons = _data;
    }

    ngOnInit(): void {
        this._form =
            this._formBuilder.create<DisputeFormFields>(DisputeFormFields);
    }

    ngOnDestroy(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._form && this._form.destroy();
    }

    /** @private */ _onSubmitClick(): void {
        this._form.checkWarningsErrors();
        if (!this._form.form.valid) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._dialogRef &&
            this._dialogRef.close({
                reason: this._disputeReasonsOpts.find(
                    (e) => e.value === this._form.value.reason,
                ).label,
                comment: this._form.value.comment
                    ? this._form.value.comment.contents
                    : null,
            });
    }
}
